import {
  FunctionComponent,
  useEffect,
  useCallback,
  useState,
  useRef,
} from 'react'
import { FaPlus } from 'react-icons/fa'
import { useHistory } from 'react-router'
import { Grid } from '@material-ui/core'

import ContainerPage from 'shared/components/ContainerPageNew'
import { colors } from 'shared/styles/colors'
import Buscar from 'shared/components/Buscar'
import { IValueBuscar } from 'shared/components/Buscar/BuscarComponent.types'
import LoadingBackdrop from 'shared/components/LoadingBackdrop'
import SnackBar from 'shared/components/SnackBar'
import Button from 'shared/components/Button'
import Table from 'shared/components/Table'
import Pagination from 'shared/components/Pagination'
import Frotista from 'modules/user/domain/entities/Frotista'
import { IListFrotista } from 'modules/user/domain/usecases/ListFrotista'

type TProps = {
  listFrotista: IListFrotista
}

const CnpjsVinculados: FunctionComponent<TProps> = ({ listFrotista }) => {
  const history = useHistory()
  const [nome, setNome] = useState('')
  const inputCnpjRef = useRef(null)
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [openErrorMessage, setOpenErrorMessage] = useState(false)
  const [tableData, setTableData] = useState<Frotista[]>([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const [recordsPerPage, setRecordsPerPage] = useState(10)

  const fetchCnpj = useCallback(
    async (nome: string, page: number) => {
      setLoading(true)
      try {
        const response = await listFrotista.execute({
          nome,
          per_page: 10,
          page,
        })

        const tableDataResponse = response.data.map(item => {
          return {
            ...item,
            handleView: () => history.push('/lotes'),
          }
        })
        setTableData(tableDataResponse)
        setLoading(false)
        setTotalRecords(response.total)
        setRecordsPerPage(response.per_page)
      } catch (e: unknown) {
        if (e instanceof Error) {
          setErrorMessage(e.message)
        } else {
          setErrorMessage('Erro ao buscar frotistas')
        }
        setOpenErrorMessage(true)
        setLoading(false)
      }
    },
    [history, listFrotista],
  )

  useEffect(() => {
    async function init() {
      fetchCnpj(nome, currentPage)
    }
    init()
  }, [nome, fetchCnpj, currentPage])

  const handleSubmit = async (values: IValueBuscar) => {
    setCurrentPage(1)
    setNome(values.valueInput)
  }

  return (
    <>
      <ContainerPage
        breadCrumb="Home / Gerenciar Conta / CNPJs vinculados"
        title="CNPJs vinculados"
        showFooterScaffold
      >
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={3}
        >
          <Grid item lg={8} xs={12}>
            <Buscar
              handleSubmit={handleSubmit}
              inputBuscarRef={inputCnpjRef}
              placeholder="Digite para buscar"
              label="Buscar"
              loading={loading}
            />
          </Grid>
          <Grid
            item
            lg={2}
            xs={12}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Button
              color={colors.white}
              style={{
                color: colors.gray,
                border: '1px solid',
              }}
              onClick={() => {
                history.goBack()
              }}
            >
              Voltar
            </Button>
          </Grid>
          <Grid
            item
            lg={2}
            xs={12}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Button
              color={colors.green}
              onClick={() => {
                history.push('/vincular-cnpj')
              }}
            >
              <FaPlus color={colors.white} /> Vincular CNPJ
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Table data={tableData} type="frotista" />
          </Grid>
        </Grid>
        <Pagination
          currentPage={currentPage}
          totalRecords={totalRecords}
          recordsPerPage={recordsPerPage}
          setCurrentPage={setCurrentPage}
        />
      </ContainerPage>
      <SnackBar
        open={openErrorMessage}
        setOpen={setOpenErrorMessage}
        severity="error"
        message={errorMessage}
        horizontal="right"
      />
      {loading && <LoadingBackdrop open={loading} color={colors.green} />}
    </>
  )
}

export default CnpjsVinculados
